const mistakes = [
  {
    wrong: 'Случайные тренинги без стратегии',
    wrongDesc: 'Компания заказывает разрозненные тренинги по мере возникновения проблем, без единой системы и плана развития.',
    right: 'Системный подход',
    rightDesc: 'Обучение встраивается в стратегию компании. Программы связаны между собой и ведут к достижению конкретных бизнес-целей.',
  },
  {
    wrong: 'Нет предварительной диагностики',
    wrongDesc: 'Тренинг заказывается без анализа реальных потребностей. В итоге — обучение не тому, чему нужно, и не тех, кому нужно.',
    right: 'Глубокая диагностика',
    rightDesc: 'Перед стартом проводим интервью, наблюдаем за работой, анализируем показатели. Программа строится на реальных данных.',
  },
  {
    wrong: 'Минимум практики, максимум теории',
    wrongDesc: 'Тренер 80% времени рассказывает теорию. Сотрудники записывают, но не пробуют. Через неделю 90% информации забыто.',
    right: '80% практики',
    rightDesc: 'Участники отрабатывают каждый навык в упражнениях, ролевых играх и на кейсах своей компании. Теория — только необходимая база.',
  },
  {
    wrong: 'Нет внедрения в работу',
    wrongDesc: 'После тренинга сотрудники возвращаются к привычным моделям поведения. Новые навыки не закрепляются и не используются.',
    right: 'Пост-тренинговое сопровождение',
    rightDesc: 'Домашние задания, трекинг прогресса, консультации после обучения. Навыки закрепляются через 21 день регулярной практики.',
  },
  {
    wrong: 'Нет оценки результата',
    wrongDesc: 'Непонятно, сработало обучение или нет. Нет метрик, нет сравнения «до» и «после». Руководство считает деньги потраченными зря.',
    right: 'Измеримые KPI',
    rightDesc: 'Фиксируем показатели до обучения и через 1-3 месяца после. Оцениваем по модели Киркпатрика: реакция, знания, поведение, результат.',
  },
];

export default function TypicalMistakes() {
  return (
    <section id="mistakes" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Типичные ошибки корпоративного обучения
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            80% компаний совершают одни и те же ошибки при организации обучения. Вот что мы видим чаще всего — и как это исправляем.
          </p>
        </div>

        <div className="space-y-8">
          {mistakes.map((item, index) => (
            <div key={index} className="grid md:grid-cols-2 gap-6">
              {/* Wrong side */}
              <div className="bg-red-50 rounded-2xl p-6 md:p-8 border border-red-100">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-red-100 rounded-lg flex items-center justify-center">
                    <i className="ri-close-circle-line text-xl text-red-500"></i>
                  </div>
                  <h3 className="text-lg font-bold text-red-700">{item.wrong}</h3>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed">{item.wrongDesc}</p>
              </div>

              {/* Right side */}
              <div className="bg-teal-50 rounded-2xl p-6 md:p-8 border border-teal-100">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-checkbox-circle-line text-xl text-teal-600"></i>
                  </div>
                  <h3 className="text-lg font-bold text-teal-700">{item.right}</h3>
                </div>
                <p className="text-gray-700 text-sm leading-relaxed">{item.rightDesc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}